import React from 'react';

import { Flex, Heading, Paragraph } from '@rover/kibble/core';
import type { ThemeHeadingSizes } from '@rover/kibble/styles';

type Props = {
  heading?: string;
  headingSize?: ThemeHeadingSizes;
  subheading?: React.ReactNode;
};

export const Header: React.FC<Props> = ({ heading, headingSize = '400', subheading }) => {
  if (!heading && !subheading) return null;
  return (
    <Flex flexDirection="column">
      {heading && (
        <Heading mb="0x" as="h2" size={headingSize}>
          {heading}
        </Heading>
      )}
      {subheading && (
        <Paragraph mt="2x" mb="3x" size="200">
          {subheading}
        </Paragraph>
      )}
    </Flex>
  );
};
